import { Dialog, Text, Image, Button, Link } from '@/ui'
import { PostAuthDialog } from './LinkContext'

export const UpgradeFromLBADialog = ({
  postAuthDialog,
  onClose,
  isOpen,
}: {
  onClose: () => void
  isOpen: boolean
  postAuthDialog: PostAuthDialog
}) => {
  return (
    <Dialog open={isOpen}>
      <Dialog.Content>
        <Dialog.Title>Your limited bank access has been updated</Dialog.Title>

        <div className="bg-neutral-25 rounded-lg p-6">
          <Image
            src="https://heard-images.s3.amazonaws.com/assets/statement_upload.svg"
            alt="banner"
            height={180}
            width={180}
          />
        </div>

        <Text className="mt-4">
          <strong>{postAuthDialog.institutionName}</strong> uses{' '}
          <strong>automatic statement uploads</strong>, which is an updated
          method of sharing statements with Heard. This allows you to directly
          manage your permissions via Plaid.
        </Text>

        <Text className="mt-4">
          Statements from this institution will continue to be automatically
          uploaded.
        </Text>

        <div className="mt-4">
          <Link
            newPage
            href="https://support.joinheard.com/hc/en-us/articles/23569956149399/"
            variant="secondary"
          >
            Learn more about statement uploads &#8594;
          </Link>
        </div>

        <Dialog.Footer>
          <Dialog.Close asChild>
            <Button variant="secondary" onClick={onClose}>
              Close
            </Button>
          </Dialog.Close>
        </Dialog.Footer>
      </Dialog.Content>
    </Dialog>
  )
}
